module.exports = __webpack_public_path__ + "static/media/icon_pos_pago_estetica.1eacf728.svg";